export default "__VITE_ASSET__BRVX2xks__"